module.exports = __webpack_public_path__ + "img/ekho_design_logo.f4e83ff7.png";